export default "__VITE_ASSET__BorustbO__"